import script from "./ProviderCostEstimator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderCostEstimator.vue?vue&type=script&setup=true&lang=ts"

import "./ProviderCostEstimator.vue?vue&type=style&index=0&id=2f64de2f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f64de2f"]])

export default __exports__